import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MobileBreakpointService {
  private mobileBreakpoint = 800;

  public isMobile$: Observable<boolean>;

  constructor() {
    this.isMobile$ = fromEvent(window, 'resize').pipe(
      debounceTime(150),
      startWith(null),
      map(() => window.innerWidth <= this.mobileBreakpoint),
      distinctUntilChanged()
    );
  }

  isMobile(): boolean {
    return window.innerWidth <= this.mobileBreakpoint;
  }
}
